/* Keep Shopify's native footer control inert until the footer is nearby. */
if (!customElements.get('dope-follow-on-shop')) {
  customElements.define('dope-follow-on-shop', class extends HTMLElement {
    connectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      const template = this.querySelector('template[data-follow-on-shop]');
      if (!template) return;
      const controller = this.controller = new AbortController();

      const mount = () => {
        if (controller.signal.aborted || !this.isConnected || !template.isConnected) return;
        this.observer?.disconnect();
        controller.abort();
        // Import the complete Liquid output, including Shopify's module scripts.
        // Its URLs, native attributes, authentication and follow action stay native.
        template.replaceWith(document.importNode(template.content, true));
      };

      if (!('IntersectionObserver' in window)) {
        mount();
        return;
      }

      // Keyboard navigation can reach the footer before it scrolls into view.
      (this.closest('footer') || this).addEventListener('focusin', mount, {
        signal: controller.signal
      });
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) mount();
      }, { rootMargin: '400px 0px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
    }
  });
}
